const web_api_root_config = {
    QA: "https://ap.qa.do.payex.live/eipp/",
    // QA_ALT: "https://axisqa.payex.live",
    // NEW_QA: "https://rearchqa.payex.live",
    UAT: "https://app.empireimports.uat.payex.live/",
    // NEW_UAT: "https://rearchuat.payex.live",
    PROD: "https://jswap.payex.live/api/",
    //LOCAL: "http://localhost:8090",
};
const overrideEnvironment: any = window['overrideEnvironment'];
const app_deploy_environment = "UAT";
const web_api_path = "";
const web_api_root =
    overrideEnvironment && overrideEnvironment.basePath
        ? overrideEnvironment.basePath
        : web_api_root_config[app_deploy_environment];
const externalLoginUrl =
    overrideEnvironment && overrideEnvironment.externalLoginUrl;
const WEB_TIME_OUT = overrideEnvironment && overrideEnvironment.WEB_TIME_OUT;
const appsBasePath = {};

if (overrideEnvironment && overrideEnvironment.apps) {
    Object.keys(overrideEnvironment.apps).forEach((appName) => {
        const appConfig = overrideEnvironment.apps[appName];
        if (appConfig.url) {
            appsBasePath[appName] = appConfig;
        }
    });
}

export const environment = {
    production: true,
    base: web_api_root,
    MANUAL_RECON_BASE_URL: "https://rearchqa.payex.live/algoriqapi/",
    // MANUAL_RECON_BASE_URL: 'https://rearchuat.payex.live/algoriqapi/',
    // MANUAL_RECON_BASE_URL: 'http://10.104.53.21:30000/algoriqapi/',
    API: {
        PayEXDC: appsBasePath["PayEXDC"] || {
            url: `${web_api_root}/${web_api_path}`,
        },
        PADD: appsBasePath["PADD"] || {
            url: `${web_api_root}/${web_api_path}`,
        },
        Algoriq: appsBasePath["Algoriq"] || {
            url: `${web_api_root}/${web_api_path}`,
        },
        Rearch: appsBasePath["Rearch"] || {
            url: `${web_api_root}/${web_api_path}`,
        },
        JSWAP: appsBasePath["JSWAP"] || {
            url: `${web_api_root}/${web_api_path}`,
        },
    },
    environment_name: app_deploy_environment,
    appName: "PayEXDC",
    externalLoginUrl: externalLoginUrl,
    environmentConfig: overrideEnvironment || {},
    deploymentInfo: {
        date: "2022-11-20",
        version: "v1.1",
        timestatmp: "",
    },
    dataUrl: (overrideEnvironment || {}).dataUrl || 'https://empireimports.qa.payex.live/PayEXDCAPI/',
    vendorUrl: (overrideEnvironment || {}).vendorUrl || 'http://vendor.ap.qa.payex.live/',
    // vendorUrl: (overrideEnvironment || {}).vendorUrl || 'http://localhost:4200/'
    JSWAPPADMIN: (appsBasePath as any)['JSWAPPADMIN']?.url || '',

};
